export default __webpack_public_path__ + "assets/04fa0552eeda5378613eb771a169720c.ttf";